import React, {
  createContext,
  useState,
  useEffect,
  useContext,
} from 'react';
import apiUrl from './apiUrl';
import { getFromStorage } from './storage';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState('');
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const localStorageToken = getFromStorage('nibi_admin_app');

      if (localStorageToken && localStorageToken.token) {
        const { token } = localStorageToken;

        try {
          const response = await fetch(
            `${apiUrl.apiUrl}/signin/token/admin/verify?token=${token}`
          );
          const json = await response.json();

          if (json.success) {
            setToken(token);
            setAuthenticated(true);
          } else {
            setAuthenticated(false);
          }
        } catch (error) {
          console.error('Error al verificar el token:', error);
          setAuthenticated(false);
        }
      }
    };

    checkAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ token, authenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
